import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';

/**
 * Portal del cliente — modalidad Informes (app `reports` del backend).
 * Emula el contrato de `portalReports.js` (V1) para que el landing y el preview se cableen igual.
 *
 * `dateRangeOverride` viaja con el shape de V1: `{predefinedPeriod}` o `{startDate, endDate}`.
 */
const me = (path) => `${API_URL}portal/me/client-reports/${path}`;
const preview = (clientId, path) => `${API_URL}portal/preview/${encodeURIComponent(clientId)}/client-reports/${path}`;

export function buildDateRangeOverridePayload(override) {
    if (!override) return null;
    if (override.predefinedPeriod) return {predefinedPeriod: override.predefinedPeriod};
    if (override.startDate && override.endDate) return {startDate: override.startDate, endDate: override.endDate};
    return null;
}

export const PortalInformesApi = {
    listMine(clientId = null) {
        const query = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
        return new APIClient(me(query)).call('GET');
    },
    renderMine(informeId, dateRangeOverride = null, clientId = null) {
        // El backend lee `client_id` del QUERY (como el V1 `queryMyReport`), no del body: con
        // `PORTAL_REQUIRE_EXPLICIT_CLIENT` prendido, en el body era un 400 (C-informes-23).
        const query = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
        const body = {date_range_override: buildDateRangeOverridePayload(dateRangeOverride)};
        return new APIClient(me(`${informeId}/render/${query}`)).call('POST', body);
    },
    listPreview(clientId) {
        return new APIClient(preview(clientId, '')).call('GET');
    },
    renderPreview(clientId, informeId, dateRangeOverride = null) {
        return new APIClient(preview(clientId, `${informeId}/render/`))
            .call('POST', {date_range_override: buildDateRangeOverridePayload(dateRangeOverride)});
    },
};
